/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
//standard libraries
import { AxiosRequestConfig } from "axios";
import { SKIP_MESSAGE_SNACKBAR } from "../../constants/message";

//custom libraries
import { METHOD } from "../../constants/requests";
import { useRestService } from "./use-rest-service";

export const useInventoryHandler = () => {
  const { executeRequest } = useRestService();

  const getInventory = (
    storeId: number,
    pageSize: number,
    ffmCenterId?: number,
    sku?: string,
    orderBy?: string,
    orderAsc?: string
  ) => {
    const query = new URLSearchParams();
    query.append("page", "1");
    if (!!pageSize) query.append("size", pageSize.toString());
    if (!!storeId) query.append("storeId", storeId.toString());
    if (!!ffmCenterId) query.append("ffmCenterId", ffmCenterId.toString());
    if (!!sku) query.append("sku", sku);
    if (!!orderBy) query.append("orderBy", orderBy);
    if (!!orderAsc) query.append("orderAsc", orderAsc);

    const requestOptions: AxiosRequestConfig | any = {
      method: METHOD.GET,
      url: `/inventory?${query.toString()}`,
      [SKIP_MESSAGE_SNACKBAR]: true,
    };

    return executeRequest(requestOptions);
  };

  const getPreviousInventory = (previousPage: string) => {
    const requestOptions: AxiosRequestConfig | any = {
      method: METHOD.GET,
      url: previousPage,
      [SKIP_MESSAGE_SNACKBAR]: true,
    };

    return executeRequest(requestOptions);
  };

  const getNextInventory = (nextPage: string) => {
    const requestOptions: AxiosRequestConfig | any = {
      method: METHOD.GET,
      url: nextPage,
      [SKIP_MESSAGE_SNACKBAR]: true,
    };

    return executeRequest(requestOptions);
  };

  return {
    getInventory,
    getPreviousInventory,
    getNextInventory,
  };
};
